import React, { useContext } from 'react';
import styled from 'styled-components';
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';

import {
  Button,
  message,
  Modal,
  Popconfirm,
  Spin,
} from '@brokerbay/design-components';
import { ManageCardContext } from './ManageCardContext';
import CardSection from './CardSection';

const UpdateCardModal = () => {
  const { modalVisible, setModalVisible, setupIntentClientSecret } =
    useContext(ManageCardContext);
  return (
    <Modal
      title="Change card"
      open={modalVisible}
      onCancel={() => setModalVisible(false)}
      footer={null}
    >
      <StyledModalBody>
        {setupIntentClientSecret ? <CardSetupForm /> : <Spin center />}
      </StyledModalBody>
    </Modal>
  );
};

// TODO: stripe sample code
export const CardSetupForm = () => {
  const {
    setupIntentClientSecret,
    setModalVisible,
    refetchCardInfo,
    onCardUpdateSuccess,
  } = useContext(ManageCardContext);
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async () => {
    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      return;
    }

    const card = elements.getElement(CardElement);

    if (!card) {
      message.error(
        'Unknown error occurred while saving your card. Please refresh the page and retry.',
      );
      return;
    }

    const result = await stripe.confirmCardSetup(setupIntentClientSecret!, {
      payment_method: {
        card,
      },
    });

    if (result.error) {
      const ERROR_TO_BE_DISPLAYED = [
        'validation_error',
        'invalid_request_error',
        'card_error',
      ];

      if (ERROR_TO_BE_DISPLAYED.includes(result.error.type)) {
        // validation error
        message.warning(result.error.message);
        return;
      }

      message.error(
        'Unknown error occurred while saving your card. Please contact customer success team.',
      );
    } else {
      // The setup has succeeded. Webhook is setup in automaton to listen for setup_intent.succeeded
      // event to update default paymentMethod for the customer.
      message.success('Card is updated.');
      setModalVisible(false);
      refetchCardInfo();
      card.clear();

      if (onCardUpdateSuccess) {
        onCardUpdateSuccess();
      }
    }
  };
  return (
    <>
      <CardSection />
      <Popconfirm
        okText="Continue"
        title={
          <span>
            This card will be saved as your default payment method,
            <br />
            and the previous card will be removed from your account.
            <br />
            Would you like to continue?
          </span>
        }
        onConfirm={handleSubmit}
        placement="bottom"
      >
        <Button
          data-cy="save-as-default-button"
          id="save-as-default"
          type="primary"
        >
          Save As Default
        </Button>
      </Popconfirm>
    </>
  );
};

const StyledModalBody = styled.div`
  padding: 25px;
  button#save-as-default {
    margin-top: 25px;
  }
`;

export default UpdateCardModal;
